import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getFeaturedCourses,
  getPromoCourses,
} from "../../../redux/features/course/courseService";
import { createregistrationRequest } from "../../../redux/features/courseRegistration/courseRegistrationService";
import { Bounce, toast } from "react-toastify";
import DropdownRef from "../../../components/DropdownRef/DropdownRef";
import LogoImg from "../../../assets/images/brand/study_hub_logo.png";
import { Link, useParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import md5 from "crypto-js/md5";
import { faClock, faUser, faCopy } from "@fortawesome/free-regular-svg-icons";
import { BsArrowUpRight } from "react-icons/bs";

const bankDetails = [
  { label: "Account Name", value: "Ardillalabs (PVT) LTD" },
  { label: "Account No", value: "120214034059" },
  { label: "Bank", value: "Sampath Bank" },
  { label: "Branch", value: "Delgoda" },
];

const StudentRegistration = () => {
  const { coordinator_id } = useParams();
  const dispatch = useDispatch();
  const payhereFormRef = useRef(null);
  const fileInputRef = useRef(null);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [isForm, setForm] = useState(true);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isPayhere, setPayhere] = useState(false);
  const [consent, setConsent] = useState(false);
  const [consentError, setConsentError] = useState("");
  const [selectedCourse, setSelectedCourse] = useState(null);

  const secretKey = "super-secret-key";

  let decryptedId = "";

  const [data, setData] = useState({
    full_name: "",
    phone_number: "",
    course_id: "",
    email: "",
    payment_type: "",
  });
  const [errors, setErrors] = useState({
    full_name: "",
    phone_number: "",
    email: "",
    course_id: "",
    payment_type: "",
    image: "",
  });

  const { promoCourses } = useSelector((state) => state.course.promoCourses);
  const { registrationRequest, success } = useSelector(
    (state) => state.courseRegistration.registrationRequestCreate
  );
  const courseDropdownRef = useRef(null);
  const branchDropdownRef = useRef(null);
  const paymentMethodDropdownRef = useRef(null);

  useEffect(() => {
    dispatch(getPromoCourses({}));
  }, [dispatch]);

  const courseList = promoCourses?.map((course) => ({
    id: course.id,
    name: course.title,
    amount: course.referral_price,
  }));

  const validateEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  const validateForm = () => {
    const errors = {};
    if (!data.full_name.trim() && !isEnabled) {
      errors.full_name = "Name is required.";
    }
    if (!data.phone_number.trim()) {
      errors.phone_number = "Phone Number is required.";
    }
    if (!data.email.trim()) {
      errors.email = "Email is required.";
    } else if (!validateEmail(data.email)) {
      errors.email = "Invalid email address.";
    }
    if (!data.course_id) {
      errors.course_id = "Course is required.";
    }
    if (!data.payment_type) {
      errors.payment_type = "Payment type is required.";
    }
    if (data.payment_type === "Transfer" && !data.image) {
      errors.image = "File is required.";
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    } else {
      return true;
    }
  };

  const showToast = (type, message) => {
    const options = {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    };

    if (type === "success") {
      toast.success(message, options);
    } else if (type === "error") {
      toast.error(message, options);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        if (!consent) {
          setConsentError("You must agree to continue with the payment.");
          return;
        }
        setDisabledBtn(true);
        const decodedParam = decodeURIComponent(coordinator_id);
        const bytes = CryptoJS.AES.decrypt(decodedParam, secretKey);
        decryptedId = bytes.toString(CryptoJS.enc.Utf8);

        const updatedData = {
          ...data,
          phone_number: data.phone_number.trim().replace(/[\s()]/g, ""),
          coordinator_id: decryptedId,
          course_id: data.course_id,
          paid_date: new Date(),
          is_user_exist: isEnabled ? "true" : "false",
          is_consent: consent,
          image: data?.image
        };

        dispatch(createregistrationRequest(updatedData)).then((response) => {
          if (response.payload.success === true) {
            if (data.payment_type === "Transfer") {
              setForm(false);
              showToast("success", response.payload.message);
              setData({
                full_name: "",
                phone_number: "",
                course_id: "",
                email: "",
                payment_type: "",
              });
              courseDropdownRef.current?.clearSelection();
              paymentMethodDropdownRef.current?.clearSelection();
              setDisabledBtn(false);
            }
            if (data.payment_type === "WhatsApp") {
              setForm(false);
              showToast("success", response.payload.message);
              setData({
                full_name: "",
                phone_number: "",
                course_id: "",
                email: "",
                payment_type: "",
              });
              courseDropdownRef.current?.clearSelection();
              paymentMethodDropdownRef.current?.clearSelection();
              window.open('https://wa.me/94702602618')
              setDisabledBtn(false);
            }
            if (data.payment_type === "Online") {
              setPayhere(true);
            }
          } else {
            showToast("error", response.payload.message);
            setDisabledBtn(false);
          }
        });
      } catch (error) {
        showToast("error", error.message);
        setDisabledBtn(false);
      }
    } else {
      setDisabledBtn(false);
    }
  };

  const handleCourse = (option) => {
    setData({ ...data, course_id: option.id, amount: option.amount });
    setErrors({ ...errors, course_id: "" });
    setSelectedCourse(
      promoCourses.find((course) => course.id === option.id) || null
    );
  };

  const validateFile = (image) => {
    if (image) {
      if (!image.type.startsWith("image/")) {
        setErrors({ ...errors, file: "Only image files are allowed." });
        return;
      }

      // if (thumbnail.size > MAX_FILE_SIZE) {
      //     setErrors({ ...errors, file: "File size exceeds 2MB limit." });
      //     return;
      // }

      setErrors({ ...errors, image: "" });
      setData({ ...data, image });
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const selectedFile = event.dataTransfer.files[0];

    if (selectedFile) {
      validateFile(selectedFile);
    }
  };

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      validateFile(selectedFile);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    if (isPayhere && payhereFormRef.current) {
      payhereFormRef.current.submit();
    }
  }, [isPayhere]);


  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);

    setTimeout(() => setCopiedIndex(null), 1500);
  };

  return (
    <div className={styles.appContainer}>
      <div className={styles.main}>
        <div className={styles.content}>
          {isForm && (
            <div className={`promo-card ${styles.regForm}`}>
              <div className={`promo-title ${styles.formHeader}`}>
                <h1 className={styles.formTitle}>New Registration</h1>
                <img src={LogoImg} alt="logo" className={styles.logo} />
              </div>
              <div className={styles.formContainer}>
                <div>
                  <ToggleSwitch
                    label="Are you an existing student?"
                    checked={isEnabled}
                    onChange={setIsEnabled}
                  />
                </div>
                <form className={styles.StudentDetailsData} noValidate>
                  {!isEnabled && (
                    <div className={styles.inputRow}>
                      <div className={styles.StudentInputFormGroup}>
                        <div
                          className={`${styles.StudentInputGroup} input-group`}
                        >
                          <div>
                            <label className={`form-label`}>
                              Full Name
                              <span className={`required-star`}>*</span>
                            </label>
                          </div>
                          <input
                            type="text"
                            placeholder="John Doe"
                            value={data.full_name}
                            onChange={(e) => {
                              const value = e.target.value;
                              const formattedValue = value
                                .trimStart()
                                .split(/\s+/)
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ");
                              setData({ ...data, full_name: formattedValue });
                              setErrors({ ...errors, full_name: "" });
                            }}
                            className={`${styles.StudentInput} primary-input`}
                          />
                        </div>
                        {errors.full_name && (
                          <p className={`text-danger error-msg`}>
                            {errors.full_name}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                  <div className={styles.inputRow}>
                    <div className={styles.StudentInputFormGroup}>
                      <div
                        className={` ${styles.StudentInputGroup} input-group`}
                      >
                        <div>
                          <label className={`form-label`}>
                            Phone Number
                            <span className={`required-star`}>*</span>
                          </label>
                        </div>
                        <input
                          type="text"
                          placeholder="07363837716"
                          value={data.phone_number}
                          onChange={(e) => {
                            setData({ ...data, phone_number: e.target.value });
                            setErrors({ ...errors, phone_number: "" });
                          }}
                          className={`${styles.StudentInput} primary-input`}
                        />
                      </div>
                      {errors.phone_number && (
                        <p className={`text-danger error-msg`}>
                          {errors.phone_number}
                        </p>
                      )}
                    </div>
                    <div className={styles.StudentInputFormGroup}>
                      <div
                        className={` ${styles.StudentInputGroup} input-group`}
                      >
                        <div>
                          <label className={`form-label`}>
                            Email<span className={`required-star`}>*</span>
                          </label>
                        </div>
                        <input
                          type="email"
                          placeholder="john.doe@mail.com"
                          value={data.email}
                          onChange={(e) => {
                            const value = e.target.value.trimStart();
                            setData({ ...data, email: value });
                            setErrors({ ...errors, email: "" });
                          }}
                          className={`${styles.StudentInput} primary-input`}
                        />
                      </div>
                      {errors.email && (
                        <p className={`text-danger error-msg`}>
                          {errors.email}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className={styles.inputRow}>
                    <div className={styles.StudentInputFormGroup}>
                      <div
                        className={` ${styles.StudentInputGroup} input-group`}
                      >
                        <div>
                          <label className={`form-label`}>
                            Course
                            <span className={`required-star`}>*</span>
                          </label>
                        </div>
                        <DropdownRef
                          ref={courseDropdownRef}
                          options={courseList}
                          placeholder="Select the course"
                          onSelect={handleCourse}
                        />
                      </div>
                      {errors.course_id && (
                        <p className={`text-danger error-msg`}>
                          {errors.course_id}
                        </p>
                      )}
                    </div>
                  </div>
                  {selectedCourse !== null && (
                    <div className={styles.courseCard}>
                      <div className={styles.courseCardContent}>
                        <div className={styles.courseCardLeft}>
                          <img
                            src={selectedCourse?.image_url}
                            className={styles.thumbImg}
                          />
                        </div>
                        <div className={styles.courseCardRight}>
                          <p className={styles.title}>
                            {selectedCourse?.title}
                          </p>
                          <p className={styles.descriptionLines}>
                            {selectedCourse?.description}
                          </p>
                          <div className={styles.iconRow}>
                            <div className={styles.iconDisplayRow}>
                              <span className={styles.iconWrapper}>
                                <FontAwesomeIcon
                                  icon={faClock}
                                  className={styles.icon}
                                />
                              </span>
                              {selectedCourse?.duration}
                            </div>
                            <div className={styles.iconDisplayRow}>
                              <span className={styles.iconWrapper}>
                                <FontAwesomeIcon
                                  icon={faUser}
                                  className={styles.icon}
                                />
                              </span>
                              {selectedCourse?.user?.full_name}
                            </div>
                          </div>
                          <div className={styles.iconRow}>
                            <div className={styles.iconDisplayRow}>
                              <p className={styles.price}>
                                Total:{" "}
                                <span className={styles.discountPrice}>
                                  {selectedCourse?.referral_price?.toLocaleString(
                                    "en-US",
                                    {
                                      style: "currency",
                                      currency: "LKR",
                                    }
                                  )}
                                </span>{" "}
                                <span className={styles.actualPrice}>
                                  {selectedCourse?.price?.toLocaleString(
                                    "en-US",
                                    {
                                      style: "currency",
                                      currency: "LKR",
                                    }
                                  )}
                                </span>
                              </p>
                            </div>
                          </div>
                          <Link
                            to={`/courses/${selectedCourse?.slug}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.viewMoreBtn} // Apply style here
                          >
                            View More <BsArrowUpRight />
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    <div className="payment-card">
                      {/* Header */}
                      <label className="payment-header">
                        <input
                          type="radio"
                          name="payment"
                          value="Online"
                          checked={data?.payment_type === "Online"}
                          onChange={(e) => {
                            setData({ ...data, payment_type: "Online" });
                            setErrors({
                              ...errors,
                              payment_type: "",
                              image: "",
                            });
                          }}
                          className={`custom-radio`}
                        />
                        <span>Debit / Credit Card</span>
                        <div className="card-icons">
                          <img
                            src="https://img.icons8.com/color/48/visa.png"
                            alt="Visa"
                          />
                          <img
                            src="https://img.icons8.com/color/48/mastercard.png"
                            alt="MasterCard"
                          />
                          <img
                            src="https://img.icons8.com/color/48/amex.png"
                            alt="Amex"
                          />
                        </div>
                      </label>
                      <hr />
                      <label className="payment-header">
                        <input
                          type="radio"
                          name="payment"
                          value="Transfer"
                          checked={data?.payment_type === "Transfer"}
                          onChange={(e) => {
                            setData({ ...data, payment_type: "Transfer" });
                            setErrors({ ...errors, payment_type: "" });
                          }}
                          className={`custom-radio`}
                        />
                        <span>Bank Transfer / Deposit</span>
                      </label>
                      {data?.payment_type === "Transfer" && (
                        <>
                          <div>
                            <p className={styles.accTitle}>Payment Instructions</p>
                            {bankDetails.map((item, index) => (
                              <div key={index} className={styles.row}>
                                <div>
                                  <p className={styles.value}>{item.label}: {item.value}</p>
                                </div>
                                {/* <button
                                                            className={styles.copyBtn}
                                                            onClick={() => handleCopy(item.value, index)}
                                                          > */}
                                {copiedIndex === index ? "Copied!" : <FontAwesomeIcon icon={faCopy} onClick={() => handleCopy(item.value, index)} className={styles.copyBtn} />}
                                {/* </button> */}
                              </div>
                            ))}
                          </div>
                          <div
                            onDrop={handleDrop}
                            onDragOver={(event) => event.preventDefault()}
                            onClick={handleClick}
                            className={`drop-input`}
                          >
                            <input
                              type="file"
                              ref={fileInputRef}
                              accept="image/*"
                              onChange={handleFileChange}
                              style={{ display: "none" }}
                            />
                            {!data.image ? (
                              <p>Drag & Drop a file here or click to select</p>
                            ) : (
                              <div className={`inserted-file`}>
                                <div className={`file-card`}>
                                  <img
                                    src={URL.createObjectURL(data.image)}
                                    alt="File Type"
                                    className={`${styles.thumbnailImg} left-icon`}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                          {errors.image && (
                            <p className={`text-danger error-msg`}>
                              {errors.image}
                            </p>
                          )}
                        </>
                      )}
                      <hr />
                      <label className="payment-header">
                        <input
                          type="radio"
                          name="payment"
                          value="WhatsApp"
                          checked={data?.payment_type === "WhatsApp"}
                          onChange={(e) => {
                            setData({ ...data, payment_type: "WhatsApp" });
                            setErrors({ ...errors, payment_type: "" });
                          }}
                          className={`custom-radio`}
                        />
                        <span>WhatsApp</span>
                      </label>
                    </div>
                    {errors.payment_type && (
                      <p className={`text-danger error-msg`}>
                        {errors.payment_type}
                      </p>
                    )}
                  </div>
                  <div className="consent-container">
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        checked={consent}
                        onChange={(e) => {
                          setConsent(e.target.checked);
                          setConsentError("");
                        }}
                      />
                      <span className="checkmark" />
                      <span className="consent-text">
                        I have read and agree to the{" "}
                        <a
                          href="/privacy-policy"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Privacy Policy
                        </a>{" "}
                        and{" "}
                        <a
                          href="/terms-and-conditions"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms & Conditions
                        </a>
                        , and I consent to proceed with the payment.
                      </span>
                    </label>

                    {consentError && (
                      <p className={`text-danger error-msg`}>{consentError}</p>
                    )}
                  </div>
                  <button
                    className={styles.createNewStudentSubmit}
                    type="Submit"
                    onClick={(e) => handleSubmit(e)}
                    disabled={disabledBtn}
                  >
                    {data.payment_type === "Online" ? `Pay Now` : `Submit`}
                  </button>
                </form>
              </div>
            </div>
          )}
          {!isForm && success && (
            <div className={`main-card ${styles.regForm} ${styles.successForm}`}>
              <div
                className={`${styles.formContainer} ${styles.reponseContainer}`}
              >
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className={styles.checkIcon}
                />
                <p className={styles.responseMsg}>
                  Your registration request
                  <br /> has been successfully submitted.
                </p>
              </div>
            </div>
          )}
          {isPayhere && (
            <form
              ref={payhereFormRef}
              method="post"
              action="https://sandbox.payhere.lk/pay/checkout"
            >
              <input type="hidden" name="merchant_id" value="1225194" />
              <input
                type="hidden"
                name="return_url"
                value={`https://www.studyhub.lk/courses`}
              />
              <input
                type="hidden"
                name="cancel_url"
                value={`https://www.studyhub.lk`}
              />
              <input
                type="hidden"
                name="notify_url"
                value={`https://api-v1.studyhub.lk/api/v1/orders/payhere-webhook-for-referral/${registrationRequest?.id}`}
              />
              <input
                type="hidden"
                name="order_id"
                value={registrationRequest?.id}
              />
              <input type="hidden" name="items" value="Course" />
              <input type="hidden" name="currency" value="LKR" />
              <input
                type="hidden"
                name="amount"
                value={parseFloat(data?.amount)
                  .toLocaleString("en-US", { minimumFractionDigits: 2 })
                  .replaceAll(",", "")}
              />
              <input type="hidden" name="first_name" value={data.full_name} />
              <input type="hidden" name="last_name" value="StudyHub" />
              <input type="hidden" name="email" value={data.email} />
              <input type="hidden" name="phone" value={data.phone_number} />
              <input type="hidden" name="address" value="No.1, Galle Road" />
              <input type="hidden" name="city" value="Colombo" />
              <input type="hidden" name="country" value="Sri Lanka" />
              <input
                type="hidden"
                name="hash"
                value={md5(
                  "1225194" +
                  `${registrationRequest?.id}` +
                  parseFloat(data?.amount)
                    .toLocaleString("en-US", { minimumFractionDigits: 2 })
                    .replaceAll(",", "") +
                  "LKR" +
                  md5("Nzg1NTczNjEzMjU5NDU4NzE5NzQwNTY4NTg5MzAzNTE5MDc0NTY0")
                    .toString()
                    .toUpperCase()
                )
                  .toString()
                  .toUpperCase()}
              />
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentRegistration;
